<div class="slider-container">
  <div class="slider-header">
    <label class="slider-label">{{ 'rem.search.radius' | translate }}</label>
    <span class="slider-value">{{ selectedValue }}</span>
  </div>

  <mat-slider
    class="custom-slider"
    [min]="0"
    [max]="values.length - 1"
    [step]="1">
    <input matSliderThumb [(ngModel)]="valueIndex" />
  </mat-slider>
</div>
